import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { FormsModule, NgForm, ReactiveFormsModule } from '@angular/forms';
import { MatRadioChange, MatRadioModule } from '@angular/material/radio'
import { BreakpointObserver, MediaMatcher } from '@angular/cdk/layout';

import { MatTabChangeEvent, MatTabsModule } from '@angular/material/tabs';
import { NgxEditorComponent, NgxEditorMenuComponent, Editor, Toolbar  } from 'ngx-editor';
import { CommonModule, DatePipe } from '@angular/common';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DateAdapter, MAT_DATE_FORMATS, MAT_NATIVE_DATE_FORMATS, provideNativeDateAdapter } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MaterialModule } from '../../../material.module';
import { Router, RouterModule } from '@angular/router';
import { TarapiService } from './tarapi.service';
import { TextMaskDateDirective } from '../../../Directives/text-mask-date-directive.directive';
import { CustomDateAdapter } from '../../../Shared/common/ng-date-parse-adapter';
import moment from 'moment';
import Swal from 'sweetalert2';
import { NotesDatashareService } from '../notes/services/notes-datashare.service';
import { RolesModel } from '../../../Data/Models/Users/roles-model';
import { UsermanagementService } from '../../../services/apps/usermanagement/usermanagement.service';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { CharityDetailsModal } from '../charities/addcharities/CharityDetailsModal';
import { CharitiesService } from '../charities/services/charities.service';
import { CharityDataShareServiceService } from '../charities/services/charity-data-share-service.service';
import { MessageServiceService } from '../../../Shared/common/message-service.service';


@Component({
  selector: 'app-trusteeannualreport',
  imports: [NgScrollbarModule, MaterialModule, MatCardModule, MatRadioModule, FormsModule, MatFormFieldModule, MatInputModule, RouterModule, CommonModule, MatTabsModule, NgxEditorComponent, NgxEditorMenuComponent, TablerIconsModule, MatDatepickerModule, ReactiveFormsModule, TextMaskDateDirective],
  templateUrl: './trusteeannualreport.component.html',
  styleUrl: './trusteeannualreport.component.scss',
  standalone: true,
  providers: [{ provide: DateAdapter, useClass: CustomDateAdapter },
  { provide: MAT_DATE_FORMATS, useValue: MAT_NATIVE_DATE_FORMATS }, DatePipe],
})

export class TrusteeannualreportComponent {
  @ViewChild('myForm') myForm!: NgForm;
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  private isInitializing = true;
  showContent = false;
  showContent1 = false;
  apFinalised: boolean = false
  showValidation1: boolean = false;
  showValidation2: boolean;
  showValidation3: boolean;
  showValidation4: boolean;
  showValidation5: boolean;
  showValidation6: boolean;
  showValidation7: boolean;
  showValidation8: boolean;
  showValidation9: boolean;
  showValidation10: boolean;
  showValidation11: boolean;
  showValidation12: boolean;
  showValidation13: boolean;
  showValidation14: boolean;
  showValidation16: boolean;
  startDate: any
  endDate: any
  today: any = moment()
  initialContent1: any;
  initialContent2: any;
  initialContent3: any;
  initialContent4: any;
  initialContent5: any;
  initialContent6: any;
  initialContent7: any;
  initialContent8: any;
  initialContent9: any;
  initialContent10: any;
  initialContent11: any;
  initialContent12: any;
  initialContent13: any;
  initialContent14: any;
  initialContent15: any;
  initialContent16: any;


  trusteeReport: boolean = true;
  StatementofRes: boolean = false;
  declaration: boolean = false;
    ReportType_Method: string | null;
  isIndependentExaminer: boolean = false;
  SubmissionStatus: any;
  showTrusteeRepport() {
    this.trusteeReport = true;
    this.StatementofRes = false;
    this.declaration = false;
  }
  showStatementofRes() {
    this.trusteeReport = false;
    this.StatementofRes = true;
    this.declaration = false;
  }
  showDeclaration() {
    debugger

    if (this.isIndependentExaminer) {

      if (this.isDeclarationDisabled()) {
        this.resetDeclarationUI();
      }

      this.trusteeReport = false;
      this.StatementofRes = false;
      this.declaration = true;
      return;
    }


    if (this.statementofTrusteesModal.includeTAR == 'Yes' || this.tarDetails.annualReport_Status == 'Yes' || this.apFinalised) {
      if ((this.statementofTrusteesModal.trusteeStatement == "<p></p>" || this.statementofTrusteesModal.trusteeStatement == "") && this.statementofTrusteesModal.includeTAR == 'Yes') {
        Swal.fire({
          html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel"></h5> <p class= "f-s-14 p-0  f-w-400 text-black" > Statement of Trustees’ Responsibility is required</p>',
          iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
          confirmButtonText: "OK",
          showCancelButton: false,
          allowOutsideClick: false
        })
        return
      }
      this.trusteeReport = false;
      this.StatementofRes = false;
      this.declaration = true;
    }
    else {
      Swal.fire({
        html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel"></h5> <p class= "f-s-14 p-0  f-w-400 text-black" >Trustees’ Annual Report or Statement of Trustees’ <br> Responsibility is required</p>',
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "OK",
        showCancelButton: false,
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed) {
          return true
        } else {
          return false
        }
      })
    }
  }


  setVisibility(event: MatRadioChange) {
    debugger
    var charityid = localStorage.getItem('currentCharityID')
    var fid = localStorage.getItem('currentPeriod')
    this.apiservice.GetTAR(fid).subscribe((data: any) => {
      debugger
      this.otherTrustees = []
      this.optionalAdvisers = []
      this.tarDetails = {
        taR_Id: 0,
        annualReport_Status: event.value,
        nameofChiefExecutive: "",
        approvedbyTrustee_SecA: this.tarDetails?.approvedbyTrustee_SecA,
        approvalDate_SecA: this.tarDetails?.approvalDate_SecA,
        description_SecB: "",
        description_SecB_2: "",
        description_SecB_3: "",
        approvedbyTrustee_SecB: "",
        approvalDate_SecB: null,
        description_SecC: "",
        description_SecC_2: "",
        description_SecC_3: "",
        description_SecC_4: "",
        approvedbyTrustee_SecC: "",
        approvalDate_SecC: null,
        description_SecD: "",
        approvedbyTrustee_SecD: "",
        approvalDate_SecD: null,
        description_SecE: "",
        description_SecE_2: "",
        description_SecE_3:null,
        description_SecE_4: "",
        description_SecE_5: null,
        description_SecE_6: "",
        approvedbyTrustee_SecE: "",
        approvalDate_SecE: null,
        description_SecF: "",
        approvedbyTrustee_SecF: "",
        approvalDate_SecF: null,
        rowmsg: null,
        charityID: 0,
        createdDate: null,
        createdby: 1,
        modifiedby: 1,
        modifiedDate: null,
        centralUserId: 1,
        userId: 1
      }
      this.charityInformation = {
        charityID: 0,
        charity_Name: "",
        other_Names: "",
        charity_Registration_Number: "",
        company_Reference_Number: "",
        addressLine1: "",
        addressLine2: "",
        addressLine3: "",
        addressLine4: "",
        city: "",
        county: "",
        country: "",
        postcode: "",
        from_CharityCommission: ""
      }

      if (data.otherTrustees) {
        this.otherTrustees = data.otherTrustees

      }
      if (data.optionalAdvisers?.length > 0) {
        this.optionalAdvisers = data.optionalAdvisers
      }
      if (data.trustees) {
        this.trustees = data.trustees
      }
      if (data.charityInformation) {
        this.charityInformation = data.charityInformation
      }
      if (localStorage.getItem('ReportType_Method') != 'Independent Examiner') {
        if (data.tarDetails) {
          data.tarDetails.annualReport_Status = event.value
          this.tarDetails = data.tarDetails
        }
      } else {

        //if (event.value === 'No') {
        //  this.clearTARData();
        //}

       /* this.clearTARData();*/
      }
      this.showValidation1 = false
      this.showValidation2 = false
      this.showValidation3 = false
      this.showValidation4 = false
      this.showValidation5 = false
      this.showValidation6 = false
      this.showValidation7 = false
      this.showValidation8 = false
      this.showValidation9 = false
      this.showValidation10 = false
      this.showValidation11 = false
      this.showValidation12 = false
      this.showValidation13 = false
      this.showValidation14 = false
      this.showValidation16 = false
      //this.mergeTrusteeNames()
    })


  }

  html = '';

  editor1: Editor;
  editor2: Editor;
  editor3: Editor;
  editor4: Editor;
  editor5: Editor;
  editor6: Editor;
  editor7: Editor;
  editor8: Editor;
  editor9: Editor;
  editor10: Editor;
  editor11: Editor;
  editor12: Editor;
  editor13: Editor;
  editor14: Editor;
  editor15: Editor;
  editor16: Editor;
  type:any

  previousValidHtml: any
  constructor(private router: Router, private sharedService: CharityDataShareServiceService,public Charities_Service: CharitiesService, private apiservice: TarapiService, private datashare: NotesDatashareService, changeDetectorRef: ChangeDetectorRef, media: MediaMatcher, private breakpointObserver: BreakpointObserver,
    private _UsermanagementService: UsermanagementService, private msgService: MessageServiceService) {
        this.ReportType_Method = localStorage.getItem('ReportType_Method')

    this.GetUserAccess()
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }
  ngOnInit(): void {
    this.sharedService.finalStatus$.subscribe((value: any) => {
      this.apFinalised = value !== '' && value === 'Completed';
    });

    this.SubmissionStatus = localStorage.getItem('SubmissionStatus');

  
    this.editor1 = new Editor();
    this.editor2 = new Editor();
    this.editor3 = new Editor();
    this.editor4 = new Editor();
    this.editor5 = new Editor();
    this.editor6 = new Editor();
    this.editor7 = new Editor();
    this.editor8 = new Editor();
    this.editor9 = new Editor();
    this.editor10 = new Editor();
    this.editor11 = new Editor();
    this.editor12 = new Editor();
    this.editor13 = new Editor();
    this.editor14 = new Editor();
    this.editor15 = new Editor();
    this.editor16 = new Editor();   
this.sharedService.ReportTypeMethod$.subscribe(value => {
  this.isIndependentExaminer = value === 'Independent Examiner';

  this.type = this.isIndependentExaminer
    ? "Independent Examiner's Report"
    : "Auditor's Report";

  debugger
 if (this.isIndependentExaminer) {
   // if (!this.tarDetails?.annualReport_Status) {
      this.tarDetails.annualReport_Status = 'No';
   // }

 //   if (!this.statementofTrusteesModal?.includeTAR) {
      this.statementofTrusteesModal.includeTAR = 'No';
  //  }
  }

});

 
    this.GetCharityDetails();
    this.GetTar();
  }

  UserRoleAccess: RolesModel;
  GetUserAccess() {
    this._UsermanagementService.GetUserRoleAccess(localStorage['userID']).subscribe(data => {
      if (data.entity.length) {
        this.UserRoleAccess = data.entity[0]
        var submitedDate = this.UserRoleAccess.currentAPSubmitDate
      }
    });
  }


  charityInformation: any = {
    charityID: 0,
    charity_Name: "",
    other_Names: "",
    charity_Registration_Number: "",
    company_Reference_Number: "",
    addressLine1: "",
    addressLine2: "",
    addressLine3: "",
    addressLine4: "",
    city: "",
    county: "",
    country: "",
    postcode: "",
    startDate: "",
    endDate: ""
  }
  optionalAdvisers: any[] = [
    //{
    //  optionalAdvisers_Id: 0,
    //  typeOfAdviser: "",
    //  advisers_Name: "",
    //  address: "",
    //  charityID: 0,
    //  createdDate: null,
    //  createdby: 1,
    //  modifiedby: 1,
    //  modifiedDate: null,
    //  centralUserId: 1,
    //  userId: 1
    //}
  ]
  otherTrustees: any[] = [
    //{
    //  otherTrustees_Id: 0,
    //  trustee_Name: "",
    //  dateActed: null,
    //  charityID: 0,
    //  createdDate:null,
    //  createdby: 1,
    //  modifiedby: 1,
    //  modifiedDate: null,
    //  centralUserId: 1,
    //  userId: 1
    //}
  ]
  tarDetails: any = {
    taR_Id: 0,
    annualReport_Status:  "Yes",
    nameofChiefExecutive: "",
    approvedbyTrustee_SecA: null,
    approvalDate_SecA: null,
    description_SecB: "",
    description_SecB_2: "",
    description_SecB_3: "",
    approvedbyTrustee_SecB: "",
    approvalDate_SecB: null,
    description_SecC: "",
    description_SecC_2: "",
    description_SecC_3: "",
    description_SecC_4: "",
    approvedbyTrustee_SecC: "",
    approvalDate_SecC: null,
    description_SecD: "",
    approvedbyTrustee_SecD: "",
    approvalDate_SecD: null,
    description_SecE: "",
    description_SecE_2: "",
    description_SecE_3: null,
    description_SecE_4: "",
    description_SecE_5: null,
    description_SecE_6: "",
    approvedbyTrustee_SecE: "",
    approvalDate_SecE: null,
    description_SecF: "",
    approvedbyTrustee_SecF: "",
    approvalDate_SecF: null,
    rowmsg: null,
    charityID: 0,
    createdDate: null,
    createdby: 1,
    modifiedby: 1,
    modifiedDate: null,
    centralUserId: 1,
    userId: 1
  }
  trustees: any = [
    //{
    //  truste_Id: 0,
    //  trustee_Name: '',
    //  office: '',
    //  datesActed: null,
    //  nameofPerson: ''
    //}
  ]
  advisorDetails: any = []
  ngOnDestroy(): void {
    this.editor1.destroy();
    this.editor2.destroy();
    this.editor3.destroy();
    this.editor4.destroy();
    this.editor5.destroy();
  }
  //{ charity_Name: '', otherName, charity_Registration_Number, company_Reference_Number, addressLine1, addressLine2, addressLine3, addressLine4, city, county, country, postcode}
  toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    // ['link', 'image'],
    ['text_color', 'background_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
  ];




  AddRow() {
    debugger
    var len = this.otherTrustees.length
    const lastDataIndex = len - 1;
    const lastDataRow = this.otherTrustees[lastDataIndex];
    if (lastDataRow?.trustee_Name.trim() !== '') {
      var newRow = {
        otherTrustees_Id: 0,
        trustee_Name: "",
        dateActed: null,
        dateActedResigned: null,
        rowmsg1: null,
        rowmsg2: null,
        charityID: 0,
        createdDate: null,
        createdby: 1,
        modifiedby: 1,
        modifiedDate: null,
        centralUserId: 1,
        userId: 1
      }
      this.otherTrustees = [...(this.otherTrustees || []), newRow]
      //this.mergeTrusteeNames()


      this.showValidation1 = false;
    }
    else {
      this.showValidation1 = true;
    }
  }
  DeleteRow(index?: any) {
    if (index !== -1) {
      const updated = [...this.otherTrustees];
      updated.splice(index, 1);
      this.otherTrustees = updated;
      //this.mergeTrusteeNames()
    }
  }
  checkoptionaladvisor(): boolean {
    let res = false
    let res1 = false
    this.optionalAdvisers.forEach((item: any) => {
      if (item.typeOfAdviser == "") {
        res = true
      }
      if (item.advisers_Name == "" && item.typeOfAdviser != "") {
        res1 = true
      }

    })
    this.showValidation2 = res
    this.showValidation16 = res1

    return !res && !res1
  }
  checkoptionaladvisor1(): boolean {
    let res = false
    this.optionalAdvisers.forEach((item: any) => {
      if (item.advisers_Name == "" || item.advisers_Name == "") {
        res = true
      }
    })
    //this.showValidation2 = res
    return !res
  }
  checkothertrustee(): boolean {

    let res = false
    this.otherTrustees.forEach((item: any) => {
      if (item.trustee_Name == "") {
        res = true
      }
    })
    this.showValidation1 = res
    return !res
  }
  checkothertrustee1(): boolean {

    let res = false
    this.otherTrustees.forEach((item: any) => {
      if (item.trustee_Name == "") {
        res = true
      }
    })
    //this.showValidation1 = res
    return !res
  }
  AddRow2() {
    debugger
    var len = this.optionalAdvisers.length
    const lastDataIndex = len - 1;
    const lastDataRow = this.optionalAdvisers[lastDataIndex];
    if (lastDataRow?.typeOfAdviser?.trim() !== '' && lastDataRow?.advisers_Name?.trim() !== '') {
      var newRow = {
        optionalAdvisers_Id: 0,
        advisorsId:0,
        typeOfAdviser: "",
        advisers_Name: "",
        address: "",
        charityID: 0,
        createdDate: null,
        createdby: 1,
        modifiedby: 1,
        modifiedDate: null,
        centralUserId: 1,
        userId: 1
      }
      this.optionalAdvisers = [...(this.optionalAdvisers || []), newRow]


      this.showValidation2 = false
      this.showValidation16 = false
    }
    else {
      if (lastDataRow?.typeOfAdviser.trim() === '') {
        this.showValidation2 = true;
      }
      if (lastDataRow?.advisers_Name.trim() === '') {
        this.showValidation16 = true;
      }
    }
  }
  DeleteRow2(index?: any) {
    if (index !== -1) {
      const updated = [...this.optionalAdvisers];
      updated.splice(index, 1);
      this.optionalAdvisers = updated;
    }
  }
  displayedColumns: string[] = ['Trustee Name', 'Office', 'DateAppointed', 'DateResigned', 'Name'];


  displayedColumnsOthertrustees: string[] = ['Name', 'DateAppointed', 'DateResigned', 'action'];



  displayedColumnsadvisers: string[] = ['Type of adviser', 'Name', 'Address', 'action'];
  advisers: any[] = [
    { type: 'data', Name: 'Richard Bell', Date: '', },
  ];
  GetTar() {
    var charityid = localStorage.getItem('currentCharityID')
    var fid = localStorage.getItem('currentPeriod')

    this.apiservice.GetTAR(fid).subscribe((data: any) => {
      debugger
      if (data.otherTrustees) {
        this.otherTrustees = data.otherTrustees
      }
      if (data.optionalAdvisers?.length > 0) {
        this.optionalAdvisers = data.optionalAdvisers
      }
      if (data.trustees) {
        this.trustees = data.trustees
      }
      if (data.charityInformation) {
        this.charityInformation = data.charityInformation
        this.startDate = moment(this.charityInformation.startDate)
        this.endDate = moment(this.charityInformation.endDate)
      }
      if (data.tarDetails) {
        if (localStorage.getItem('ReportType_Method') != 'Independent Examiner') {
          this.tarDetails = data.tarDetails
          this.initialContent1 = data.tarDetails?.description_SecB
          this.initialContent2 = data.tarDetails?.description_SecC
          this.initialContent3 = data.tarDetails?.description_SecD
          this.initialContent4 = data.tarDetails?.description_SecE
          this.initialContent5 = data.tarDetails?.description_SecF
          this.initialContent6 = data.tarDetails?.description_SecB_2
          this.initialContent7 = data.tarDetails?.description_SecB_3
          this.initialContent8 = data.tarDetails?.description_SecC_2
          this.initialContent9 = data.tarDetails?.description_SecC_3
          this.initialContent10 = data.tarDetails?.description_SecC_4
          this.initialContent11 = data.tarDetails?.description_SecE_2
          //this.initialContent12 = data.tarDetails?.description_SecE_3
          this.initialContent13 = data.tarDetails?.description_SecE_4
          // this.initialContent14 = data.tarDetails?.description_SecE_5
          this.initialContent15 = data.tarDetails?.description_SecE_6
          if (this.trustees.some((person: any) => person.trustee_Name === this.tarDetails.approvedbyTrustee_SecA)) {

          }
          else {
            this.tarDetails.approvedbyTrustee_SecA = null
          }
        } else {
          debugger
         // this.clearTARData();
          if (data.tarDetails) {


            this.tarDetails = data.tarDetails;

            if (this.tarDetails.annualReport_Status === 'No') {
              this.clearTARData();
              //alert("helo")
            }
            else {
              this.tarDetails = data.tarDetails;

              // restore editor initial values
              this.initialContent1 = data.tarDetails?.description_SecB;
              this.initialContent2 = data.tarDetails?.description_SecC;
              this.initialContent3 = data.tarDetails?.description_SecD;
              this.initialContent4 = data.tarDetails?.description_SecE;
              this.initialContent5 = data.tarDetails?.description_SecF;
              this.initialContent6 = data.tarDetails?.description_SecB_2;
              this.initialContent7 = data.tarDetails?.description_SecB_3;
              this.initialContent8 = data.tarDetails?.description_SecC_2;
              this.initialContent9 = data.tarDetails?.description_SecC_3;
              this.initialContent10 = data.tarDetails?.description_SecC_4;
              this.initialContent11 = data.tarDetails?.description_SecE_2;
              this.initialContent13 = data.tarDetails?.description_SecE_4;
              this.initialContent15 = data.tarDetails?.description_SecE_6;
            }
          }
        }
      }
      if (data.statementofTrusteesModal) {
        debugger
        this.statementofTrusteesModal = data.statementofTrusteesModal
        this.tarDetails.approvalDate_SecA = this.statementofTrusteesModal.approvalDate
        this.tarDetails.approvedbyTrustee_SecA = this.statementofTrusteesModal.trusteeName
        this.initialContent16 = data.statementofTrusteesModal?.trusteeStatement
      }
      if (data.advisorDetails) {
        this.advisorDetails = data.advisorDetails
      }
      //this.mergeTrusteeNames()
    })

  }
  isLastDataRow1(index: number): boolean {
    var f1 = this.otherTrustees.length ? this.otherTrustees.length : 0
    const footerIndex = f1 - 1
    if (footerIndex >= 0) {
      return index === footerIndex;
    }
    return false;
  }
  isLastDataRow2(index: number): boolean {
    var f1 = this.optionalAdvisers.length ? this.optionalAdvisers.length : 0
    const footerIndex = f1 - 1
    if (footerIndex >= 0) {
      return index === footerIndex;
    }
    return false;
  }
  allTrustees: string[] = [];

  //mergeTrusteeNames() {
  //  debugger
  //  const namesFromTrustees = this.trustees.map((t: any) => t.trustee_Name?.trim()).filter(Boolean);
  //  const namesFromOtherTrustees = this.otherTrustees.map((t: any) => t.trustee_Name?.trim()).filter(Boolean);

  //  this.allTrustees = [...namesFromTrustees, ...namesFromOtherTrustees];
  //}

  SaveTar() {
    debugger
    if (this.apFinalised) {
      if (this.type == "Independent Examiner's Report") {
        this.router.navigate(['independentexaminerreport']);
      } else {
        this.router.navigate(['audit-report']);
      }
    }

    else if (!this.isDeclarationDisabled() && (!this.isSectionGValid() || this.tarDetails.rowmsg)) {
      return;
    }

    else {

      if (this.tarDetails.annualReport_Status == 'Yes') {
        if ((this.tarDetails.description_SecB == "" || this.tarDetails.description_SecB == "<p></p>") && (this.tarDetails.description_SecB_2 == "" || this.tarDetails.description_SecB_2 == "<p></p>")
          && (this.tarDetails.description_SecB_3 == "" || this.tarDetails.description_SecB_3 == "<p></p>") && (this.tarDetails.description_SecC == "" || this.tarDetails.description_SecC == "<p></p>") &&
          (this.tarDetails.description_SecC_3 == "" || this.tarDetails.description_SecC_3 == "<p></p>") && (this.tarDetails.description_SecC_2 == "" || this.tarDetails.description_SecC_2 == "<p></p>") &&
          (this.tarDetails.description_SecC_4 == "" || this.tarDetails.description_SecC_4 == "<p></p>") && (this.tarDetails.description_SecD == "" || this.tarDetails.description_SecD == "<p></p>") &&
          (this.tarDetails.description_SecE == "" || this.tarDetails.description_SecE == "<p></p>") && (this.tarDetails.description_SecE_2 == "" || this.tarDetails.description_SecE_2 == "<p></p>") &&
          (this.tarDetails.description_SecE_3 == "" || this.tarDetails.description_SecE_3 == "<p></p>" || this.tarDetails.description_SecE_3 == null) && (this.tarDetails.description_SecE_4 == "" || this.tarDetails.description_SecE_4 == "<p></p>") &&
          (this.tarDetails.description_SecE_5 == "" || this.tarDetails.description_SecE_5 == "<p></p>" || this.tarDetails.description_SecE_5 == null) && (this.tarDetails.description_SecE_6 == "" || this.tarDetails.description_SecE_6 == "<p></p>")) {
          Swal.fire({
            html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel"></h5> <p class= "f-s-14 p-0  f-w-400 text-black" >At least one section from B to E of the Trustees Annual Report must be completed before proceeding.</p>',
            iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
            confirmButtonText: "OK",
            showCancelButton: false,
            allowOutsideClick: false
          })
          return
        }
      }
      var charityid = localStorage.getItem('currentCharityID')
      var uid = localStorage.getItem('CurrentuserID')
      var cid = localStorage.getItem('CentralUserId')
      var fid = localStorage.getItem('currentPeriod')
      this.tarDetails.charityID = charityid ? +charityid : 0
      this.tarDetails.userId = uid ? +uid : 0
      this.tarDetails.centralUserId = cid ? +cid : 0
      this.tarDetails.createdby = uid ? +uid : 0
      this.tarDetails.modifiedby = uid ? +uid : 0
      this.tarDetails.financialPeriodsID = fid ? +fid : 0
      this.tarDetails.approvalDate_SecA = this.tarDetails.approvalDate_SecA ? moment(this.tarDetails.approvalDate_SecA).format('YYYY-MM-DD') : null
      this.statementofTrusteesModal.approvalDate = this.tarDetails.approvalDate_SecA
      this.statementofTrusteesModal.trusteeName = this.tarDetails.approvedbyTrustee_SecA
      if (this.statementofTrusteesModal.includeTAR == "No") {
        this.statementofTrusteesModal.trusteeStatement = this.MaindeFaultStatement
      }
      this.statementofTrusteesModal.charityID = charityid ? +charityid : 0
      this.statementofTrusteesModal.userId = uid ? +uid : 0
      this.statementofTrusteesModal.modifiedby = uid ? +uid : 0
      this.statementofTrusteesModal.centralUserId = cid ? +cid : 0
      this.statementofTrusteesModal.createdby = uid ? +uid : 0
      this.statementofTrusteesModal.financialPeriodsID = fid ? +fid : 0

      this.otherTrustees.forEach((item: any) => {
        item.dateActed = item.dateActed ? moment(item.dateActed).format('YYYY-MM-DD') : null
        item.dateActedResigned = item.dateActedResigned ? moment(item.dateActedResigned).format('YYYY-MM-DD') : null
      })
      this.trustees.forEach((item: any) => {
        item.datesActed = item.datesActed ? moment(item.datesActed).format('YYYY-MM-DD') : null
        item.dateActedResigned = item.dateActedResigned ? moment(item.dateActedResigned).format('YYYY-MM-DD') : null
      })
      //this.optionalAdvisers.forEach((item: any) => { item.advisers_Name = item.advisers_Name.toString() })
      if (this.tarDetails.annualReport_Status === 'No') {
        //this.clearTARData();
      }

      if (this.statementofTrusteesModal.includeTAR === 'No') {
        this.clearStatementData();
        //this.clearDeclarationData();
      }

      if (this.isDeclarationDisabled()) {
        this.resetDeclarationUI();
      }

      const payload = {
        charityInformation: this.charityInformation,
        trustees: this.trustees,
        optionalAdvisers: this.optionalAdvisers,
        otherTrustees: this.otherTrustees,
        tarDetails: this.tarDetails,
        statementofTrusteesModal: this.statementofTrusteesModal
      }
      this.apiservice.saveTAR(payload).subscribe((Data) => {
        debugger
        this.isdirty = false
        this.datashare.setisdirty(false)
        if (this.type == "Independent Examiner's Report") {
          this.router.navigate(['independentexaminerreport']);
        } else {
          this.router.navigate(['audit-report']);
        }
      })
    }
  }
  selectedTabIndex = 0;
  canNavigateToTab(index: number): boolean {
    if (index === 1 && !this.isSectionAValid()) {
      return false;
    }

    if (index === 7 && !this.isSectionGValid()) {
      return false;
    }

    return true;
  }

  isSectionAValid(): boolean {
    this.checkothertrustee();
    this.checkoptionaladvisor();
    return this.checkothertrustee() && this.checkoptionaladvisor()

  }
  isSectionAValid1(): boolean {
    this.checkothertrustee1();
    this.checkoptionaladvisor1();
    return this.checkothertrustee1() && this.checkoptionaladvisor1()

  }

  isSectionGValid(): boolean {

    if (this.isDeclarationDisabled()) {
      return true;
    }
    
    this.showValidation3 = this.tarDetails.approvedbyTrustee_SecA == null;
    this.showValidation4 = this.tarDetails.approvalDate_SecA == null;

    return !!(
      this.tarDetails.approvedbyTrustee_SecA &&
      this.tarDetails.approvalDate_SecA
    );
  }



  //isSectionGValid(): boolean {

  //  if (this.isIndependentExaminer) {
  //    return true; 
  //  }

  //  this.showValidation3 = this.tarDetails.approvedbyTrustee_SecA == null
  //  this.showValidation4 = this.tarDetails.approvalDate_SecA == null
  //  return this.tarDetails.approvedbyTrustee_SecA && this.tarDetails.approvalDate_SecA
  //}
  isSectionCValid(): boolean {

    this.showValidation7 = this.tarDetails.approvedbyTrustee_SecC == ""
    this.showValidation8 = this.tarDetails.approvalDate_SecC == null
    return this.tarDetails.approvedbyTrustee_SecC && this.tarDetails.approvalDate_SecC
  }
  isSectionDValid(): boolean {

    this.showValidation9 = this.tarDetails.approvedbyTrustee_SecD == ""
    this.showValidation10 = this.tarDetails.approvalDate_SecD == null
    return this.tarDetails.approvedbyTrustee_SecD && this.tarDetails.approvalDate_SecD
  }
  isSectionEValid(): boolean {

    this.showValidation11 = this.tarDetails.approvedbyTrustee_SecE == ""
    this.showValidation12 = this.tarDetails.approvalDate_SecE == null
    return this.tarDetails.approvedbyTrustee_SecE && this.tarDetails.approvalDate_SecE
  }
  isSectionFValid(): boolean {

    this.showValidation13 = this.tarDetails.approvedbyTrustee_SecF == ""
    this.showValidation14 = this.tarDetails.approvalDate_SecF == null
    return this.tarDetails.approvedbyTrustee_SecF && this.tarDetails.approvalDate_SecF
  }

  onTabChange(event: MatTabChangeEvent) {

    const newIndex = event.index;
    this.selectedTabIndex = newIndex;
    if (!this.canNavigateToTab(newIndex)) {
      this.goToPreviousTab()
      return;
    }

   
  }

  goToNextTab(value: any): void {
    debugger
    if (this.isAnyDateInvalid() && value =='yes') {
      return
    }
    const nextIndex = this.selectedTabIndex + 1;

    if (value == 'yes') {

      if (this.canNavigateToTab(nextIndex)) {
        this.selectedTabIndex = nextIndex;
        if (nextIndex > 4) {
          this.showStatementofRes()
        }
      } else {

      }
    }
    else {
      this.showStatementofRes()
    }
  }
  goToPreviousTab() {

    const prevIndex = this.selectedTabIndex - 1;
    if (prevIndex >= 0) {
      this.selectedTabIndex = prevIndex;
    }
    else {
      this.Back()
    }
  }
  backToCharityOverView() {
    debugger
    localStorage.setItem('isFromBasicInfo', 'true')
    this.router.navigate(['/charity']);

  }
  Back() {
    debugger
    this.router.navigate(['/Accountnotes']);

  }
  next() {
    debugger
    this.router.navigate(['/statementoftrustees'])
  }
  get advisorTypes(): string[] {

    return Array.from(
      new Set(
        this.advisorDetails.map((x: any) => x.professionalAdvisors_Type)
      )
    );
  }
  getAdvisorNamesByType(type: string): any[] {
    return this.advisorDetails.filter((x: any) => x.professionalAdvisors_Type === type);
  }
  onAdvisorNameChange(type: string, name: string, index: number): void {
    debugger
    const matchedAdvisor = this.advisorDetails.find((adv: any) =>
      //adv.professionalAdvisors_Type === type &&
      //adv.professionalAdvisors_Name === name
      adv.advisorsId == name
    );

    if (matchedAdvisor) {
      const fullAddress = [
        matchedAdvisor.professionalAdvisors_Address_Line_1,
        matchedAdvisor.professionalAdvisors_Address_Line_2,
        matchedAdvisor.professionalAdvisors_City,
        matchedAdvisor.professionalAdvisors_Postcode
      ]
        .filter(Boolean) // removes undefined/null/empty values
        .join(', ');

      this.optionalAdvisers[index].address = fullAddress;
      this.optionalAdvisers[index].advisers_Name = matchedAdvisor.professionalAdvisors_Name;
    } else {
      this.optionalAdvisers[index].address = '';
    }
  }

  isDateInvalid(dateString: string): boolean {
    if (!dateString) return false;
    const date = new Date(dateString);
    var res1 = date < this.startDate
    var res2 = date > this.endDate
    return res1 || res2 ;
  }
  isDatesActedResignedValid(datesActed: string, datesActedResigned: string): boolean {

    if (!datesActed || !datesActedResigned) return true; // If one is missing, skip this check
    const acted = new Date(datesActed);
    const resigned = new Date(datesActedResigned);
    var res = resigned >= acted
    return res;
  }

  isAnyDateInvalid(): boolean {
    const trusteesInvalid = this.trustees.some((trustee: any) =>
      !this.isDatesActedResignedValid(trustee.datesActed, trustee.dateActedResigned) ||
      trustee.rowmsg1 ||
      trustee.rowmsg2
    );

    const otherTrusteesInvalid = this.otherTrustees.some(trustee =>
      this.isDateInvalid(trustee.datesActed) ||
      this.isDateInvalid(trustee.dateActedResigned) ||
      !this.isDatesActedResignedValid(trustee.datesActed, trustee.dateActedResigned) ||
      trustee.rowmsg1 ||
      trustee.rowmsg2
    );

    return trusteesInvalid || otherTrusteesInvalid;
  }
  MAX_LENGTH = 2500;
  trim(html: string, name: any): void {
    debugger
    const plainText = this.stripHtmlTags(html);
    const trimmedText = plainText.slice(0, this.MAX_LENGTH).trimEnd();

    // Convert trimmed plain text back to HTML preserving spaces and line breaks
    // const trimmedHtml = this.plainTextToHtmlWithSpaces(trimmedText);

    // Update UI & model with trimmed HTML
    this.setEditorContentByName(name, trimmedText);
    this.updateTarDetails(name, trimmedText);

  }

  handleEditorInput(html: string, name: any): void {
    //this.isdirty = true;
    //this.datashare.setisdirty(true)
    const plainText = this.stripHtmlTags(html);

    if (plainText.length <= this.MAX_LENGTH) {
      this.previousValidHtml = html;
      this.updateTarDetails(name, html);
    } else {
      // Trim the plain text to MAX_LENGTH
      const trimmedText = plainText.slice(0, this.MAX_LENGTH);

      // Convert trimmed plain text back to HTML preserving spaces and line breaks
      const trimmedHtml = this.plainTextToHtmlWithSpaces(trimmedText);

      // Update UI & model with trimmed HTML
      this.setEditorContentByName(name, trimmedHtml);
      this.updateTarDetails(name, trimmedHtml);
    }
  }
  handleEditorInput1(html: string, name: any): void {
    debugger
    if (html) {
      if (name == "description_SecB") {
        if (html != this.initialContent1) {
          this.isdirty = true;
          this.datashare.setisdirty(true)
        }
      }
      if (name == "description_SecB_2") {
        if (html != this.initialContent6) {
          this.isdirty = true;
          this.datashare.setisdirty(true)
        }
      }
      if (name == "description_SecB_3") {
        if (html != this.initialContent7) {
          this.isdirty = true;
          this.datashare.setisdirty(true)
        }
      }
      if (name == "description_SecC") {
        if (html != this.initialContent2) {
          this.isdirty = true;
          this.datashare.setisdirty(true)
        }
      }
      if (name == "description_SecC_2") {
        if (html != this.initialContent8) {
          this.isdirty = true;
          this.datashare.setisdirty(true)
        }
      }
      if (name == "description_SecC_3") {
        if (html != this.initialContent9) {
          this.isdirty = true;
          this.datashare.setisdirty(true)
        }
      }
      if (name == "description_SecC_4") {
        if (html != this.initialContent10) {
          this.isdirty = true;
          this.datashare.setisdirty(true)
        }
      }
      if (name == "description_SecD") {
        if (html != this.initialContent3) {
          this.isdirty = true;
          this.datashare.setisdirty(true)
        }
      }
      if (name == "description_SecE") {
        if (html != this.initialContent4) {
          this.isdirty = true;
          this.datashare.setisdirty(true)
        }
      }
      if (name == "description_SecE_2") {
        if (html != this.initialContent11) {
          this.isdirty = true;
          this.datashare.setisdirty(true)
        }
      }
      //if (name == "description_SecE_3") {
      //  if (html != this.initialContent12) {
      //    this.isdirty = true;
      //    this.datashare.setisdirty(true)
      //  }
      //}
      if (name == "description_SecE_4") {
        if (html != this.initialContent13) {
          this.isdirty = true;
          this.datashare.setisdirty(true)
        }
      }
      //if (name == "description_SecE_5") {
      //  if (html != this.initialContent14) {
      //    this.isdirty = true;
      //    this.datashare.setisdirty(true)
      //  }
      //}
      if (name == "description_SecE_6") {
        if (html != this.initialContent15) {
          this.isdirty = true;
          this.datashare.setisdirty(true)
        }
      }
      if (name == "trusteeStatement") {
        if (html != this.initialContent16) {
          this.isdirty = true;
          this.datashare.setisdirty(true)
        }
      }

    }
    //this.isdirty = true;
    //this.datashare.setisdirty(true)
    // Update UI & model with trimmed HTML
    this.setEditorContentByName(name, this.SethtmlTo2500(html));
    this.updateTarDetails(name, this.SethtmlTo2500(html));
  }

  //limitDecimal(event: any): void {
  //  let value = event.target.value;

  //  value = value
  //    .replace(/[^0-9.-]/g, '')       // remove $,£,¥,₠,letters,spaces
  //    .replace(/(?!^)-/g, '')         // only one minus at start
  //    .replace(/^(-?\d{8})\d+/, '$1') // max 8 digits
  //    .replace(/(\.\d{2}).+/, '$1');  // max 2 decimals

  //  event.target.value = value;
  //}
  SethtmlTo2500(html: string): string {
    debugger
    var maxLength: number = 2500
    const div = document.createElement('div');
    div.innerHTML = html;

    let charCount = 0;
    const walker = document.createTreeWalker(div, NodeFilter.SHOW_TEXT, null);
    const nodesToRemove: Node[] = [];

    while (walker.nextNode()) {
      const node = walker.currentNode as Text;
      const remaining = maxLength - charCount;

      if (remaining <= 0) {
        nodesToRemove.push(node);
      } else if (node.nodeValue!.length > remaining) {
        node.nodeValue = node.nodeValue!.substring(0, remaining);
        charCount = maxLength;
      } else {
        charCount += node.nodeValue!.length;
      }
    }

    nodesToRemove.forEach(node => node.parentNode?.removeChild(node));

    // Remove empty elements left behind
    const cleanEmptyElements = (element: HTMLElement) => {
      Array.from(element.children).forEach(child => {
        cleanEmptyElements(child as HTMLElement);
        if (
          child.childNodes.length === 0 ||
          (child.childNodes.length === 1 && child.childNodes[0].nodeType === Node.TEXT_NODE && !(child.textContent || '').trim())
        ) {
          child.remove();
        }
      });
    };

    cleanEmptyElements(div);

    return div.innerHTML;
  }
  updateTarDetails(name: string, html: string) {
    debugger
    switch (name) {
      case 'description_SecB':
        this.tarDetails.description_SecB = html;
        break;
      case 'description_SecB_2':
        this.tarDetails.description_SecB_2 = html;
        break;
      case 'description_SecB_3':
        this.tarDetails.description_SecB_3 = html;
        break;
      case 'description_SecC':
        this.tarDetails.description_SecC = html;
        break;
      case 'description_SecC_2':
        this.tarDetails.description_SecC_2 = html;
        break;
      case 'description_SecC_3':
        this.tarDetails.description_SecC_3 = html;
        break;
      case 'description_SecC_4':
        this.tarDetails.description_SecC_4 = html;
        break;
      case 'description_SecD':
        this.tarDetails.description_SecD = html;
        break;
      case 'description_SecE':
        this.tarDetails.description_SecE = html;
        break;
      case 'description_SecE_2':
        this.tarDetails.description_SecE_2 = html;
        break;
      //case 'description_SecE_3':
      //  this.tarDetails.description_SecE_3 = html;
      //  break;
      case 'description_SecE_4':
        this.tarDetails.description_SecE_4 = html;
        break;
      //case 'description_SecE_5':
      //  this.tarDetails.description_SecE_5 = html;
      //  break;
      case 'description_SecE_6':
        this.tarDetails.description_SecE_6 = html;
        break;
      case 'trusteeStatement':
        this.statementofTrusteesModal.trusteeStatement = html 
        break;
    }
  }

  setEditorContentByName(name: string, html: string) {
    switch (name) {
      case 'description_SecB':
        this.editor1.setContent(html);
        break;
      case 'description_SecB_2':
        this.editor6.setContent(html);
        break;
      case 'description_SecB_3':
        this.editor7.setContent(html);
        break;
      case 'description_SecC':
        this.editor2.setContent(html);
        break;
      case 'description_SecC_2':
        this.editor8.setContent(html);
        break;
      case 'description_SecC_3':
        this.editor9.setContent(html);
        break;
      case 'description_SecC_4':
        this.editor10.setContent(html);
        break;
      case 'description_SecD':
        this.editor3.setContent(html);
        break;
      case 'description_SecE':
        this.editor4.setContent(html);
        break;
      case 'description_SecE_2':
        this.editor11.setContent(html);
        break;
      //case 'description_SecE_3':
      //  this.editor12.setContent(html);
      //  break;
      case 'description_SecE_4':
        this.editor13.setContent(html);
        break;
      //case 'description_SecE_5':
      //  this.editor14.setContent(html);
      //  break;
      case 'description_SecE_6':
        this.editor15.setContent(html);
        break;
      case 'trusteeStatement':
        this.editor16.setContent(html);
        break;
    }
  }

  stripHtmlTags(html: string): string {
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent || div.innerText || '';
  }

  // Convert plain text to HTML with spaces and line breaks preserved
  plainTextToHtmlWithSpaces(text: string): string {
    return text
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/  /g, " &nbsp;")      // preserve multiple spaces
      .replace(/\n/g, "<br>");        // preserve line breaks
  }

  //MAX_LENGTH = 2500;
  //handleEditorInput(html: string ,name:any): void {
  //  debugger
  //  this.isdirty=true
  //  const plainText = this.stripHtmlTags(html);

  //  //if (plainText.length <= this.MAX_LENGTH) {
  //  //  this.previousValidHtml = html;
  //  //  if (name == 'description_SecB') {
  //  //    this.tarDetails.description_SecB = html;
  //  //  }
  //  //  if (name == 'description_SecC') {
  //  //    this.tarDetails.description_SecC = html;
  //  //  }
  //  //  if (name == 'description_SecD') {
  //  //    this.tarDetails.description_SecD = html;
  //  //  }
  //  //  if (name == 'description_SecE') {
  //  //    this.tarDetails.description_SecE = html;
  //  //  }
  //  //  if (name == 'description_SecF') {
  //  //    this.tarDetails.description_SecF = html;
  //  //  }
  //  //} else {
  //    // Revert visually and logically
  //    if (name == 'description_SecB') {
  //      this.editor1.setContent(plainText.slice(0, 2500));  // ⬅️ This updates the UI
  //      //this.tarDetails.description_SecB = plainText.slice(0, 2500);
  //    }
  //    if (name == 'description_SecC') {
  //      this.editor2.setContent(this.previousValidHtml);  // ⬅️ This updates the UI
  //      this.tarDetails.description_SecC = this.previousValidHtml;
  //    }
  //    if (name == 'description_SecD') {
  //      this.editor3.setContent(this.previousValidHtml);  // ⬅️ This updates the UI
  //      this.tarDetails.description_SecD = this.previousValidHtml;
  //    }
  //    if (name == 'description_SecE') {
  //      this.editor4.setContent(this.previousValidHtml);  // ⬅️ This updates the UI
  //      this.tarDetails.description_SecE = this.previousValidHtml;
  //    }
  //    if (name == 'description_SecF') {
  //      this.editor5.setContent(this.previousValidHtml);  // ⬅️ This updates the UI
  //      this.tarDetails.description_SecF = this.previousValidHtml;

  //  }
  //}

  //stripHtmlTags(html: string): string {
  //  const div = document.createElement('div');
  //  div.innerHTML = html;
  //  return div.textContent || div.innerText || '';
  //}

  //getPlainTextLength(html: string): number {
  //  return this.stripHtmlTags(html).length;
  //}
  isValidDate(date: any): boolean {
    if (!date) return false;
    if (typeof date === 'string') {
      date = new Date(date);
    }
    return date instanceof Date && !isNaN(date.getTime());
  }
  checkdate(event: any, row: any) {
    debugger
    const baseDate = moment('01/01/1753', 'DD/MM/YYYY');     // 1st Jan 1753
    const compareDate = moment(event.target.value, 'DD/MM/YYYY');
    if (!event.target.value || (moment(event.target.value, 'DD/MM/YYYY', true).isValid() && compareDate.isBefore(baseDate))) {
      row.rowmsg = null
      return
    }
    if (moment(event.target.value, 'DD/MM/YYYY', true).isValid()) {
      row.rowmsg = null
      if (compareDate < this.startDate || compareDate > this.today) {
        row.rowmsg = "Approval Date should be on or between Accounting Period Start and Today's Date"
      }
    }
    else {
      row.rowmsg = 'Approval Date is invalid'
    }
  }
  checkdate4(event: any, row: any) {
    debugger
    const baseDate = moment('01/01/1753', 'DD/MM/YYYY');     // 1st Jan 1753
    const compareDate = moment(event.target.value, 'DD/MM/YYYY');
    if (!event.target.value || (moment(event.target.value, 'DD/MM/YYYY', true).isValid() && compareDate.isBefore(baseDate))) {
      row.rowmsg2 = null
      return
    }
    if (moment(event.target.value, 'DD/MM/YYYY', true).isValid()) {
      row.rowmsg2 = null
      // trustees.dateActedResigned && (trustees.dateActedResigned < startDate || trustees.dateActedResigned > endDate)
      if (compareDate < this.startDate || compareDate > this.endDate) {
        row.rowmsg2 = 'Date Resigned should be on or between Accounting Period Start and End Date'
      }
      else if (row.datesActed) {
        if (new Date(row.dateActedResigned) < new Date(row.datesActed)) {
          if (row.rowmsg1 == 'Date Appointed must be on or before Date Resigned') {
            row.rowmsg2 = null
          }
          else {
            row.rowmsg2 = 'Date Resigned must be on or after Date Appointed'
          }
        }
        else {
          row.rowmsg2 = null
          //row.rowmsg1=null
        }
      }
      else {
        row.rowmsg2 = null
      }
    }
    else {
      row.rowmsg2 = 'Date Resigned is invalid'
    }
  }
  checkdate3(event: any, row: any) {
    debugger
    const baseDate = moment('01/01/1753', 'DD/MM/YYYY');     // 1st Jan 1753
    const compareDate = moment(event.target.value, 'DD/MM/YYYY');
    if (!event.target.value || (moment(event.target.value, 'DD/MM/YYYY', true).isValid() && compareDate.isBefore(baseDate))) {
      row.rowmsg1 = null
      return
    }
    if (moment(event.target.value, 'DD/MM/YYYY', true).isValid()) {
      row.rowmsg1 = null
      // const targetdate = new Date(event.target.value)
      if (compareDate < this.startDate || compareDate > this.endDate) {
        row.rowmsg1 = 'Date Appointed should be on or between Accounting Period Start and End Date'
      }
      else if (row.dateActedResigned) {

        if (new Date(row.datesActed) > new Date(row.dateActedResigned)) {
          if (row.rowmsg2 == 'Date Resigned must be on or after Date Appointed') {
            row.rowmsg1 = null
          }
          else {
            row.rowmsg1 = 'Date Appointed must be on or before Date Resigned'
          }
        }
        else {
          row.rowmsg1 = null
          // row.rowmsg2 = null
        }
      }
      else {
        row.rowmsg1 = null
      }
    }
    else {
      row.rowmsg1 = 'Date Appointed is invalid'
    }
  }
  checkdate2(event: any, row: any) {
    debugger
    const baseDate = moment('01/01/1753', 'DD/MM/YYYY');     // 1st Jan 1753
    const compareDate = moment(event.target.value, 'DD/MM/YYYY');
    if (!event.target.value || (moment(event.target.value, 'DD/MM/YYYY', true).isValid() && compareDate.isBefore(baseDate))) {
      row.rowmsg2 = null
      return
    }
    if (moment(event.target.value, 'DD/MM/YYYY', true).isValid()) {
      row.rowmsg2 = null
      if (compareDate < this.startDate || compareDate > this.endDate) {
        row.rowmsg2 = 'Date Resigned should be on or between Accounting Period Start and End Date'
      }
      else if (row.dateActed) {
        if (new Date(row.dateActedResigned) < new Date(row.dateActed)) {

          if (row.rowmsg1 == 'Date Appointed must be on or before Date Resigned') {
            row.rowmsg2 = null
          }
          else {
            row.rowmsg2 = 'Date Resigned must be on or after Date Appointed'
          }
        }
        else {
          row.rowmsg2 = null
          //row.rowmsg1 = null
        }
      }
      else {
        row.rowmsg2 = null
      }
    }
    else {
      row.rowmsg2 = 'Date Resigned is invalid'
    }
  }
  checkdate1(event: any, row: any) {
    debugger
    const baseDate = moment('01/01/1753', 'DD/MM/YYYY');     // 1st Jan 1753
    const compareDate = moment(event.target.value, 'DD/MM/YYYY');
    if (!event.target.value || (moment(event.target.value, 'DD/MM/YYYY', true).isValid() && compareDate.isBefore(baseDate))) {
      row.rowmsg1 = null
      return
    }
    if (moment(event.target.value, 'DD/MM/YYYY', true).isValid()) {
      row.rowmsg1 = null
      if (compareDate < this.startDate || compareDate > this.endDate) {
        row.rowmsg1 = 'Date Appointed should be on or between Accounting Period Start and End Date'
      }
      else if (row.dateActedResigned) {
        if (new Date(row.dateActed) > new Date(row.dateActedResigned)) {
          if (row.rowmsg2 == 'Date Resigned must be on or after Date Appointed') {
            row.rowmsg1 = null
          }
          else {
            row.rowmsg1 = 'Date Appointed must be on or before Date Resigned'
          }
        }
        else {
          row.rowmsg1 = null
          //row.rowmsg2 = null
        }
      }
      else {
        row.rowmsg1 = null
      }

    }
    else {
      row.rowmsg1 = 'Date Appointed is invalid'
      return
    }

  }
  removevalid1(event: any, row: any) {
    debugger
    if (!event.target.value) {
      row.rowmsg1 = null
      if (row.rowmsg2 == 'Date Resigned must be on or after Date Appointed') {
        row.rowmsg2 = null
      }
      return
    }
  }
  removevalid2(event: any, row: any) {
    debugger
    if (!event.target.value) {
      row.rowmsg2 = null
      if (row.rowmsg1 == 'Date Appointed must be on or before Date Resigned') {
        row.rowmsg1 = null
      }
      return
    }
  }
  removevalid3(event: any, row: any) {
    debugger
    if (!event.target.value) {
      row.rowmsg1 = null
      if (row.rowmsg2 == 'Date Resigned must be on or after Date Appointed') {
        row.rowmsg2 = null
      }
      return
    }
  }
  removevalid4(event: any, row: any) {
    debugger
    if (!event.target.value) {
      row.rowmsg2 = null
      if (row.rowmsg1 == 'Date Appointed must be on or before Date Resigned') {
        row.rowmsg1 = null
      }
      return
    }
  }
  removevalid(event: any, row: any) {
    if (!event.target.value) {
      row.rowmsg = null
      return
    }
  }
  isdirty: boolean = false
  dirty() {
    this.isdirty = true
    this.datashare.setisdirty(true)
  }
  CanDeactivate(): any {
    debugger
    if (this.isdirty) {

      return Swal.fire({
        html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Leave the page?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Are you sure you want to leave this page. <br> Data entered will not be saved.</p>',
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Leave",
        showCancelButton: true,
        cancelButtonText: "Stay",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          debugger
          this.isdirty = false;
          this.datashare.setisdirty(false)
          return true
        } else {
          localStorage.setItem("currentCharityIDFromSwitch", "");
          return false
        }
      })
    } else {
      return true
    }
  }

  //---------------------------code for statement of responsibility------------------------------------

  setVisibility1(event: MatRadioChange) {
    debugger;

    const value = event.value;
    const fid = localStorage.getItem('currentPeriod');

   
    this.statementofTrusteesModal.includeTAR = value;

   
    if (value === 'No') {


      this.resetDeclarationUI();

      this.tarDetails.approvedbyTrustee_SecA = null;
      this.tarDetails.approvalDate_SecA = null;
      this.tarDetails.rowmsg = null;

      this.showValidation3 = false;
      this.showValidation4 = false;

      this.statementofTrusteesModal.trusteeStatement = this.MaindeFaultStatement;


      if (this.editor16) {
        this.editor16.setContent(this.MaindeFaultStatement);
      }

      return;
    }

    this.apiservice.GetTAR(fid).subscribe((data: any) => {

     
      this.statementofTrusteesModal = {
        trusteeStatementID: 0,
        includeTAR: value,
        trusteeStatement: "",
        trusteeName: this.statementofTrusteesModal?.trusteeName ?? null,
        approvalDate: this.statementofTrusteesModal?.approvalDate ?? null,
        charityID: 0,
        createdDate: null,
        createdby: 1,
        modifiedby: 1,
        modifiedDate: null,
        centralUserId: 1,
        userId: 1,
        financialPeriodsID: 0
      };

     
      if (data?.statementofTrusteesModal) {
        data.statementofTrusteesModal.includeTAR = value;
        this.statementofTrusteesModal = data.statementofTrusteesModal;
        this.initialContent16 = data.statementofTrusteesModal.trusteeStatement;

        
        if (this.editor16) {
          this.editor16.setContent(this.statementofTrusteesModal.trusteeStatement);
        }
      }
      else {
      
        this.statementofTrusteesModal.trusteeStatement = this.MaindeFaultStatement;

        if (this.editor16) {
          this.editor16.setContent(this.MaindeFaultStatement);
        }
      }
    });
  }

 
  CountryACT: any = ''
  CountryName: string;
  MaindeFaultStatement: string;
  deFaultStatement: string
  CharityDetails: CharityDetailsModal[];
  statementofTrusteesModal = {
    trusteeStatementID: 0,
    includeTAR: "No",
    trusteeStatement: "",
    trusteeName:null,
    approvalDate:null,
    charityID: 0,
    createdDate: null,
    createdby: 1,
    modifiedby: 1,
    modifiedDate: null,
    centralUserId: 1,
    userId: 1,
    financialPeriodsID: 0
  }

  GetCharityDetails() {
    var charityID = localStorage.getItem('currentCharityID') != '' ? localStorage.getItem('currentCharityID') : 0
    this.Charities_Service.EditCharityDetails(charityID).subscribe((data: CharityDetailsModal[]) => {
      debugger
      this.CharityDetails = data

      //< mat - option value = "england_wales" > England and Wales < /mat-option>
      //  < mat - option value = "scotland" > Scotland < /mat-option>
      //    < mat - option value = "northern_ireland" > Northern Ireland < /mat-option>

      if (data[0].charity_Type == 'Unincorporated Charity') {
        if (this.CharityDetails[0].jurisdiction_Charity == "england_wales") {
          this.CountryACT = `the Charity (Accounts and Reports) Regulations 2008`
          this.CountryName = 'England and Wales'
        }

        else if (this.CharityDetails[0].jurisdiction_Charity == "scotland") {
          this.CountryACT = `the Charities and Trustee Investment (Scotland) Act 2005 and the Charities Accounts (Scotland) Regulations 2006`
          this.CountryName = 'Scotland'
        }
        else {
          this.CountryACT = `The Charities (Accounts and Reports) Regulations (Northern Ireland) 2015]`
          this.CountryName = 'Northern Ireland'
        }

        this.MaindeFaultStatement = `<p>The trustees are responsible for preparing the Trustees' Annual Report and the financial statements in accordance with applicable law and United Kingdom Accounting Standards (United Kingdom Generally Accepted Accounting Practice).</p>

        <p>The law applicable to charities in ${this.CountryName} requires the trustees to prepare financial statements for each financial year which give a true and fair view of the state of affairs of the charity and of the incoming resources and application of resources of the charity for that period. In preparing these financial statements, the trustees are required to:</p>

         <ul>
            <li>select suitable accounting policies and apply them consistently;</li>
            <li>observe the methods and principles in the Charities SORP;</li>
            <li>make judgments and estimates that are reasonable and prudent;</li>
            <li>state whether applicable accounting standards have been followed, subject to any departures disclosed and explained in the financial statements; and</li>
            <li>prepare the accounts on a going concern basis unless it is inappropriate to presume that the charity will continue in business.</li>
         </ul>
        <p>The trustees are responsible for maintaining proper accounting records which disclose with reasonable accuracy at any time the financial position of the charity and to enable them to ensure that the accounts comply with the Charities Act 2011 ${this.CountryACT} and the provisions of the trust deed. They are also responsible for safeguarding the assets of the charity and hence for taking reasonable steps for the prevention and detection of fraud and other irregularities.`
      }
      else {

        if (this.CharityDetails[0].jurisdiction_Charity == "england_wales")
          this.CountryACT = `the accounts comply with the Companies Act 2006`

        else if (this.CharityDetails[0].jurisdiction_Charity == "scotland")
          this.CountryACT = `the Charities and Trustee Investment (Scotland) Act 2005 and the Charities Accounts (Scotland) Regulations 2006]`
        else
          this.CountryACT = ``

        this.MaindeFaultStatement = `<p>The trustees (who are also directors of ${this.CharityDetails[0].charity_Name} for the purposes of company law) are responsible for preparing the Trustees' Annual Report and the financial statements in accordance with applicable law and United Kingdom Accounting Standards (United Kingdom Generally Accepted Accounting Practice).</p>

        <p>Company law requires the trustees to prepare financial statements for each financial year. Under company law the trustees must not approve the financial statements unless they are satisfied that they give a true and fair view of the state of affairs of the charitable company and of the incoming resources and application of resources, including the income and expenditure, of the charitable company for that period. In preparing these financial statements, the trustees are required to:</p>

          <ul>
            <li>select suitable accounting policies and apply them consistently;</li>
            <li>observe the methods and principles in the Charities SORP;</li>
            <li>make judgments and estimates that are reasonable and prudent;</li>
            <li>state whether applicable UK accounting standards have been followed, subject to any departures disclosed and explained in the financial statements; and</li>
            <li>prepare the accounts on a going concern basis unless it is inappropriate to presume that the charity will continue in business.</li>
         </ul>
        <p>The trustees are responsible for maintaining proper accounting records which disclose with reasonable accuracy at any time the financial position of the charitable company and to enable them to ensure that ${this.CountryACT}. They are also responsible for safeguarding the assets of the charitable company and hence for taking reasonable steps for the prevention and detection of fraud and other irregularities.</p>`;

      }
      //this.statementofTrusteesModal.trusteeStatement = this.MaindeFaultStatement
      //this.editor16.setContent(this.deFaultStatement)
      
    })
  }
  SetDefault() {
    debugger
    this.deFaultStatement = this.MaindeFaultStatement
    this.editor16.setContent(this.deFaultStatement)
  }

  UnlockandAmend() {
    debugger
    var fid: any = localStorage.getItem('currentPeriod') ? localStorage.getItem('currentPeriod') : 0
    if (this.UserRoleAccess.m1Amend) {
      Swal.fire({
        html: `<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Are you sure?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black" style="line-height:22px; padding-right: 30px !important;"> Unlocking the accounting period will allow you to amend the filed accounts and correct any errors. After making any changes, the accounts must be submitted again as an Amended filing. Do you want to unlock and amend the accounting period?</p>`,
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Yes",
        showCancelButton: true,
        cancelButtonText: "No",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this._UsermanagementService.UnfreezeAP(+fid).subscribe((data: any) => {
            debugger
            this.sharedService.setFinalStatus('InCompleted');
            localStorage.setItem('apFinalised', 'InCompleted')
          })
          //this.save("FinaliseandClose");
        }
        else { }
      })
    }
    else {
      Swal.fire({
        html: '<p class= "f-s-14 p-0 m-y-5 f-w-400 text-black" style="line-height:22px"><b>Access Denied</b> <br/> You do not have the required permissions to perform this action</p>',
        iconHtml: '<span class="fa fa-warning"></span>',
        confirmButtonText: "OK",
        allowOutsideClick: false
      })
    }
  }
  UnfreezeAP() {
    debugger
    var fid: any = localStorage.getItem('currentPeriod') ? localStorage.getItem('currentPeriod') : 0
    if (this.UserRoleAccess.m1Submit) {
      Swal.fire({
        html: `<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Are you sure?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black" style="line-height:22px; padding-right: 30px !important;"> Do you want to unlock the Accounting Period? </p>`,
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Yes",
        showCancelButton: true,
        cancelButtonText: "No",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this._UsermanagementService.UnfreezeAP(+fid).subscribe((data: any) => {
            debugger
            const message = "Accounting Period unlocked successfully";
            this.msgService.showToastMessage('success', message)
            this.sharedService.setFinalStatus('InCompleted');
            localStorage.setItem('apFinalised', 'InCompleted')
          })
        }
      })
    } else {
      Swal.fire({
        html: '<p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> <b>Access Denied</b> <br/> You do not have the required permissions to perform this action</p>',
        iconHtml: '<span class="fa fa-warning"></span>',
        confirmButtonText: "OK",
        allowOutsideClick: false
      })
    }
  }
  gotoSubmissions() {
    var fid: any = localStorage.getItem('currentPeriod') ? localStorage.getItem('currentPeriod') : 0
    if (this.UserRoleAccess.m1Submit) {
      this._UsermanagementService.GoToSubmissions()
    } else {
      Swal.fire({
        html: '<p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> <b>Access Denied</b> <br/> You do not have the required permissions to perform this action</p>',
        iconHtml: '<span class="fa fa-warning"></span>',
        confirmButtonText: "OK",
        allowOutsideClick: false
      })
    }

  }

  isDeclarationDisabled(): boolean {
    return (
      this.tarDetails?.annualReport_Status === 'No' &&
      this.statementofTrusteesModal?.includeTAR === 'No'
    );
  }

  onDecimalInput(event: any, field: string): void {
    let value = event.target.value
      .replace(/[^0-9.-]/g, '')
      .replace(/(?!^)-/g, '')
      .replace(/^(-?\d{8})\d+/, '$1')
      .replace(/(\.\d{2}).+/, '$1');

    event.target.value = value;

    
    this.tarDetails[field] = value === '' ? null : Number(value);
  }

  clearDeclarationData() {
    this.tarDetails.approvedbyTrustee_SecA = null;
    this.tarDetails.approvalDate_SecA = null;
    this.tarDetails.rowmsg = null;
    this.showValidation3 = false;
    this.showValidation4 = false;
  }

  clearStatementData() {
    this.statementofTrusteesModal.trusteeStatement = this.MaindeFaultStatement;
  }

  clearTARData() {
    this.tarDetails.description_SecB = '';
    this.tarDetails.description_SecB_2 = '';
    this.tarDetails.description_SecB_3 = '';
    this.tarDetails.description_SecC = '';
    this.tarDetails.description_SecD = '';
    this.tarDetails.description_SecE = '';
    this.tarDetails.description_SecB= "";
    this.tarDetails.description_SecB_2= "";
    this.tarDetails.description_SecB_3= "";
    this.tarDetails.approvedbyTrustee_SecB= "";
    this.tarDetails.approvalDate_SecB= null;
    this.tarDetails.description_SecC= "";
    this.tarDetails.description_SecC_2= "";
    this.tarDetails.description_SecC_3= "";
    this.tarDetails.description_SecC_4= "";
    this.tarDetails.approvedbyTrustee_SecC= "";
    this.tarDetails.approvalDate_SecC= null;
    this.tarDetails.description_SecD= "";
    this.tarDetails.approvedbyTrustee_SecD= "";
    this.tarDetails.approvalDate_SecD= null;
    this.tarDetails.description_SecE= "";
    this.tarDetails.description_SecE_2= "";
    this.tarDetails.description_SecE_3= null;
    this.tarDetails.description_SecE_4= "";
    this.tarDetails.description_SecE_5= null;
    this.tarDetails.description_SecE_6= "";
    this.tarDetails.approvedbyTrustee_SecE= "";
    this.tarDetails.approvalDate_SecE= null;
    this.tarDetails.description_SecF= "";
    this.tarDetails.approvedbyTrustee_SecF= "";
    this.tarDetails.approvalDate_SecF= null;
  }
  resetDeclarationUI() {
    
    this.tarDetails.approvedbyTrustee_SecA = null;
    this.tarDetails.approvalDate_SecA = null;
    this.tarDetails.rowmsg = null;

    
    this.showValidation3 = false;
    this.showValidation4 = false;

   
    setTimeout(() => {
      this.tarDetails.approvedbyTrustee_SecA = null;
      this.tarDetails.approvalDate_SecA = null;
    });
  }

}


